import React, { useEffect, useState } from 'react';
import { authService } from '../../services/api';
import styles from './Sobre.module.css';

const Sobre: React.FC = () => {
  const [appVersion, setAppVersion] = useState('0.0.0');

  useEffect(() => {
    authService.getHealth()
      .then((health) => setAppVersion(health.version))
      .catch(() => setAppVersion('0.0.0'));
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* Cabeçalho */}
        <div className={styles.header}>
          <img src="/app_icon.png" alt="App ícone" className={styles.logoIcon} />
          <h1 className={styles.systemName}>Ilumina Pesqueira</h1>
          <p className={styles.subtitle}>Plataforma de Gestão de Iluminação Pública</p>
          <span className={styles.badge}>Versão {appVersion}</span>
        </div>

        {/* Organização */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Organização</h2>
          <div className={styles.infoRow}>
            <span className={styles.label}>Órgão</span>
            <span className={styles.value}>Prefeitura Municipal de Pesqueira – PE</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>Setor responsável</span>
            <span className={styles.value}>Secretaria de Serviços Públicos</span>
          </div>
        </section>

        <div className={styles.divider} />

        {/* Desenvolvimento */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Desenvolvimento</h2>
          <div className={styles.infoRow}>
            <span className={styles.label}>Desenvolvido por</span>
            <span className={styles.value}>SICTEC – Secretaria de Inovação, Ciência, Tecnologia e Comunicação Social</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>Ano</span>
            <span className={styles.value}>2026</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>Domínios</span>
            <span className={styles.value}>
              iluminada.pesqueira.pe.gov.br (painel interno)<br />
              iluminacaopublica.pesqueira.pe.gov.br (portal do munícipe)
            </span>
          </div>
        </section>

        <div className={styles.divider} />

        {/* Tecnologias */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Tecnologias Utilizadas</h2>
          <div className={styles.techGrid}>
            <div className={styles.techCard}>
              <span className={styles.techIcon}>⚙️</span>
              <div>
                <p className={styles.techName}>Back-end</p>
                <p className={styles.techDetail}>Go 1.23 · Gin · GORM · MySQL 8 · JWT · Docker</p>
              </div>
            </div>
            <div className={styles.techCard}>
              <span className={styles.techIcon}>🌐</span>
              <div>
                <p className={styles.techName}>Painel Administrativo</p>
                <p className={styles.techDetail}>React 19 · TypeScript · CSS Modules · jsPDF · Recharts</p>
              </div>
            </div>
            <div className={styles.techCard}>
              <span className={styles.techIcon}>🏛️</span>
              <div>
                <p className={styles.techName}>Portal do Munícipe</p>
                <p className={styles.techDetail}>React 19 · TypeScript · Turnstile · jsPDF</p>
              </div>
            </div>
            <div className={styles.techCard}>
              <span className={styles.techIcon}>📱</span>
              <div>
                <p className={styles.techName}>Mobile</p>
                <p className={styles.techDetail}>Flutter 3.24 · Dart · Provider · Google Maps · Android 9+</p>
              </div>
            </div>
          </div>
        </section>

        <div className={styles.divider} />

        {/* Funcionalidades */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Funcionalidades</h2>
          <ul className={styles.featureList}>
            <li>Abertura e acompanhamento de ordens de serviço</li>
            <li>Portal público para solicitações do munícipe com validação anti-robô</li>
            <li>Ordens avulsas geradas em campo via aplicativo mobile</li>
            <li>Cadastro e gestão de catálogo de materiais, lâmpadas e refletores</li>
            <li>Checklist de conclusão com foto georreferenciada do poste</li>
            <li>Coleta de assinaturas digitais dos técnicos</li>
            <li>Verificação inline de barramento duplicado na criação de OS</li>
            <li>Filtro de ordens por CPF do munícipe (portal público)</li>
            <li>Recuperação de senha com validação por código</li>
            <li>Geração de comprovante PDF de conclusão</li>
            <li>Relatório gerencial com taxa de execução e materiais</li>
            <li>Burndown de ordens com linha ideal por dias úteis</li>
            <li>Mapa de coordenadas por barramento/poste</li>
            <li>Controle de usuários e perfis de acesso</li>
            <li>Política de privacidade em conformidade com a LGPD</li>
          </ul>
        </section>

        <div className={styles.footer}>
          <p>© 2026 Prefeitura Municipal de Pesqueira. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
};

export default Sobre;
